(function () {

    var harriApp = angular.module('harriApp');

    function InterviewManageAvailabilityModalController($scope, modalData, InterviewManageAvailability) {
        $scope.interviewManageAvailability = new InterviewManageAvailability($scope);
        $scope.interviewManageAvailability.load(modalData);

        $scope.saveForm = function (data) {
            $scope.interviewManageAvailability.save()
                .then(function () {
                    $scope.close();
                    $scope.$digest();
                }, function (err) {
                    $scope.interviewManageAvailability.saving = false;
                });
        };

        $scope.close = function () {
            $scope.interviewManageAvailability.destroy();
            $scope.$hide();
        };
    }

    harriApp.controller("InterviewManageAvailabilityModalController", [
        '$scope',
        'modalData',
        'InterviewManageAvailability',
        InterviewManageAvailabilityModalController
    ]);
})();